<template>
    <div class="content">

        <div class="d-flex justify-content-between align-items-center d-flex-wrap mb-2">

            <h3 class="m-0 text-info font-weight-bold"><i class="fa fa-flag"></i> Configuración de Países</h3>

            <b-button id="show-btn" @click="() => onHandleOpenModalToCreateOrEdit('CREATE')" variant="outline-info"><i
                    class="fa fa-plus mr-1"></i> Nuevo registro</b-button>
        </div>

        <b-table :hover="true" :fields="tableConfig.fields"
            :items="tableConfig.dataFields.data" :busy="tableConfig.loading" responsive>

            <!-- País -->
            <template #cell(country_name)="data">
                {{ `${data.item.country.name} [${data.item.country.code}]` }}
            </template>

            <!-- Tipos de documentos -->
            <template #cell(type_documents)="data">
                <b-badge variant="light" v-for="typeDocument in data.item.type_documents" :key="typeDocument.id"
                    class="m-1 px-2 py-1">
                    {{ typeDocument.document_type.lista }}
                </b-badge>
            </template>

            <!-- Lenguajes -->
            <template #cell(languages)="data">
                <b-badge v-for="language in data.item.language_relations" :key="language.language.id"
                    v-text="`${language.language.name} [${language.language.code}]`" class="m-1 px-2 py-1"></b-badge>
            </template>

            <!-- Lenguaje nativo -->
            <template #cell(native_language)="data">
                <b-badge variant="info" v-for="language in data.item.language_relations.filter(x => x.is_native)"
                    :key="language.id" v-text="`${language.language.name} [${language.language.code}]`"
                    class="m-1 px-2 py-1"></b-badge>
            </template>

            <!-- Aplica criterios de renovación -->
            <template #cell(regulatory_review_criteria)="data">
                {{ data.item.has_regulatory_review ? `Aplica ${data.item.regulatory_review_period} años` : 'No aplica'
                }}
            </template>

            <!-- Aplica para OECD -->
            <template #cell(does_it_belong_to_the_OECD)="data">
                {{ data.item.show_regulation_chart ? 'Aplica' : 'No aplica' }}
            </template>

            <!-- Aplica para OECD -->
            <template #cell(is_active)="data">
                <b-badge :variant="data.item.is_active ? 'info' : 'danger'"
                    v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
            </template>

            <!-- Acciones -->
            <template #cell(actions)="data">
                <el-tooltip class="ml-2" content="Editar ítem" placement="bottom" effect="light">
                    <i class="fa fa-lg fa-edit text-info cursor-pointer" @click="() => onHandleEdit(data.item)" />
                </el-tooltip>
                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactiva registro' : 'Activa registro'"
                    placement="top" effect="light">
                    <el-button type="text" size="sm" @click="() => onHandleChangeState(data.item)"
                        :class="`${!data.item.is_active ? 'text-info' : 'text-danger'}`">
                        <i class="fa fa-lg" :class="`fa-${data.item.is_active ? 'close' : 'check-circle-o'}`"></i>
                    </el-button>
                </el-tooltip>
            </template>

        </b-table>

        <!-- Validaciones e información -->
        <div>
            <div v-if="tableConfig.dataFields.total <= 0 && !tableConfig.loading" class="text-center w-100 p-4">
                <div class="text-center text-muted">
                    <i class="d-block fa fa-info-circle" :style="{ fontSize: '45px' }"></i>
                    <p>No hay datos para mostrar...</p>
                </div>
            </div>
        </div>

        <!-- Paginación -->
        <div>
            <div class="d-flex justify-content-end align-items-center pr-4 mt-4">

                <el-pagination :total="tableConfig.dataFields.total" v-model="tableConfig.dataFields.current_page"
                    :current-page="tableConfig.dataFields.current_page" :page-sizes="[10, 20, 30, 100]"
                    :page-size="tableConfig.dataFields.per_page" layout="total, sizes, prev, pager, next"
                    @size-change="loadAfterChangeSizePagination" @current-change="loadAfterChangePagePagination" />

            </div>
            <br />
        </div>

        <!-- Modal para crear/editar -->
        <b-modal :id="modalCountry.id" hide-footer size="lg">
            <template #modal-title>
                {{ modalCountry.action === 'EDIT' ? 'Editar' : 'Crear' }} configuración del País
            </template>

            <FormComponent />
        </b-modal>

    </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

// Componentes
import FormComponent from './Form.vue'

export default {

    name: "AdministrationCountriesHistory",

    components: {
        FormComponent
    },

    data() {
        return {
            countrySettingActive: null
        }
    },

    computed: {

        // Estados para el modulo del Naciones unidas - gre
        ...mapState("AdministrationCountries", [
            'tableConfig',
            'modalCountry'
        ]),

    },

    methods: {

        // Acciones para el modulo del configuración de países
        ...mapActions("AdministrationCountries", [
            'getAll',
            'changeState'
        ]),

        // Acciones para el modulo del configuración de países
        ...mapGetters("AdministrationCountries", [
            'getAllCountrySettings'
        ]),

        // Acciones para el modulo del configuración de países
        ...mapMutations("AdministrationCountries", [
            'setTableConfigPagination',
            'resetCountry',
            'setCountry',
            'setAction',
        ]),

        /**
         * Cambiar la cantidad de ítems por página en la paginación.
         * @param integer per_page 
         */
        async loadAfterChangeSizePagination(per_page = 10) {
            this.setTableConfigPagination({ ...this.tableConfig.dataFields, per_page, page: 1 });
            await this.getAll(this.tableConfig.dataFields);
        },

        /**
         * Cambiar entre páginas en la paginación.
         * @param integer page 
         */
        async loadAfterChangePagePagination(page = 1) {
            this.setTableConfigPagination({ ...this.tableConfig.dataFields, page });
            await this.getAll(this.tableConfig.dataFields);
        },

        /**
         * Abrir modal para ver editar.
         * @param Object countrySetting 
         */
        onHandleEdit(countrySetting) {
            this.resetCountry();

            // Mapear custom names desde los type_documents
            const customNames = countrySetting.type_documents
                .filter(td => td.custom_name) // Solo los que tienen custom_name
                .map(td => ({
                    type_document_id: td.document_type_id,
                    custom_name: td.custom_name
                }));

            let payload = {
                id: countrySetting.id,
                country_id: countrySetting.country_id,
                show_regulation_chart: !!countrySetting.show_regulation_chart,
                has_not_adopted_sga: !!countrySetting.has_not_adopted_sga,
                is_main_sga_country: !!countrySetting.is_main_sga_country,
                has_regulatory_review: !!countrySetting.has_regulatory_review,
                regulatory_review_period: countrySetting.regulatory_review_period,
                type_documents: countrySetting.type_documents.map(x => x.document_type_id),
                languages: countrySetting.language_relations.map(x => x.language_id),
                assignedLanguages: countrySetting.language_relations.map(x => ({ ...x.language, is_native: !!x.is_native })),
                danger_type_ids: countrySetting.danger_type_ids || [],
                custom_names: customNames,
                compliance_rule_docs: countrySetting.type_documents
                    .filter(td => td.is_compliance_rule)
                    .map(td => td.document_type_id),
            }

            this.setCountry(payload);
            this.onHandleOpenModalToCreateOrEdit('EDIT')
        },

        /**
         * Cambiar estado del registro.
         * @param Object countrySetting 
         */
        onHandleChangeState(countrySetting) {
            this.countrySettingActive = countrySetting
            this.$alertConfirmation({
                icon: 'info',
                showConfirmButton: true,
                showCancelButton: true,
                cancelButtonColor: '#acacac',
                title: 'Configuración de Países',
                text: `¿Esta seguro que desea ${ countrySetting.is_active ? 'inactivar' : 'activar' } el País ${ countrySetting.country.name }?`,
                onConfirm: this.onHandleConfirmChangeState
            });
        },

        async onHandleConfirmChangeState() {
            this.changeState({ country_setting_id: this.countrySettingActive.id, callback: this.callbackChangeState });
        },

        async callbackChangeState(status)  {
            if(!status) return 

            this.countrySettingActive = null
            this.getAll({ page: this.tableConfig.dataFields.current_page, per_page: this.tableConfig.dataFields.per_page })
        },

        /**
         * Abrir modal para crear/editar.
         * @param [String|null] action 
         */
        onHandleOpenModalToCreateOrEdit(action = 'CREATE') {
            if (action === 'CREATE') this.resetCountry();
            this.setAction(action);
            this.$bvModal.show(this.modalCountry.id)
        }

    }
};
</script>

<style scoped>
.icon-list-empty {
    font-size: 40px;
}

.content {
    max-width: 100%;
    overflow-x: auto;
    min-width: 400px;
}
</style>
